import { DeleteUserParams } from 'types/services';
import { asyncTimeout } from 'utils/asyncTimeout';
import { SERVICES_MOCK_DELAY } from 'utils/constants';

export const deleteUser = async (params: DeleteUserParams) => {
  await asyncTimeout(SERVICES_MOCK_DELAY);
};
